<template>
    <div class="animated fadeIn order-history">
        <div class="card">
            <div class="card-header">
                <div>Order History</div>
                <button class="btn btn-success btn-order-blank-sims" id="orderBlankSimsButton" v-on:click="goToOrder"><i class="fa fa-shopping-cart"></i>Order Blank SIMs</button>
            </div>
            <div class="card-body order-history-card">
                <div class="siot-table-wrapper">
                    <div class="siot-table-header">
                        <div class="siot-table-header-left">
                            <div class="siot-table-search">
                                <div class="siot-table-search-field">
                                    <input type="text" @keyup="searchKeyUp" @keydown="searchKeyDown()" id="orderHistorySearch" v-model="filter" placeholder="Search" />
                                </div>
                            </div>

                            <div class="siot-table-sort">
                                <button id="simManagmentSort" @click="shwoHideSort()" class="btn btn-primary mobile-sort-btn"><i aria-hidden="true" class="fa fa-sort"></i>Sort</button>
                            </div>
                        </div>
                        <div class="siot-table-header-right">
                            <div class="siot-table-export">
                                <button class="btn btn-primary btn-on-right" id="ordersHistoryExportButton" @click="showExportSelect()">Export orders</button>
                            </div>
                            <div class="siot-table-size">
                                <label for="size-page" class="show-label">Display:</label>
                                <select id="size-page" class="form-control custom-select" v-model="sortSettings.size" v-on:change="sizePage">
                                    <option value="40">40</option>
                                    <option value="60">60</option>
                                    <option value="80">80</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div v-if="mobileVisible == true" class="order-history-mobile-wrapper">
                        <div class="list-mobile">
                            <div v-for="(item, index) in orderList"  v-bind:key="item.orderId"  @click="showOrderDetails(item.orderId)" :class="['item-mobile', item.status == 'PAYMENT_ERROR' ? 'payment-failed' : '']">
                                <div class="item-header-mobile">
                                    <div class="info-wrapper-mobile">
                                        <strong class="order-date">{{item.dateCreated}}</strong>
                                        <strong class="order-value">$ {{item.totalPrice.toFixed(2)}} {{item.currency}}</strong>
                                    </div>
                                </div>
                                <div class="data-table-mobile">
                                    <div class="row-mobile">
                                        <div class="icon-mobile">
                                            <img src="../../assets/img/mobile-icons/mobile-icon19.svg" alt="">
                                        </div>
                                        <div class="info">
                                            <span class="value">{{item.orderId}}</span>
                                        </div>
                                    </div>
                                    <div :class="['row-mobile', item.status == 'PAYMENT_ERROR' ? 'payment-failed' : '']">
                                        <div class="icon-mobile">
                                            <img src="../../assets/img/mobile-icons/mobile-icon16.svg" alt="">
                                        </div>
                                        <div class="info">
                                            <span class="value">{{item.statusMessage}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="siot-table-content">
                        <div class="siot-table table-order-history">
                            <table class="table b-table table-striped table-hover">
                                <thead role="rowgroup">
                                    <tr role="row">
                                        <th v-on:click="changesSort" role="columnheader" aria-colindex="1" aria-label="Date" aria-sort="none">Date</th>
                                        <th v-on:click="changesSort" role="columnheader" aria-colindex="2" aria-label="Invoice" aria-sort="none">Invoice</th>
                                        <th v-on:click="changesSort" role="columnheader" aria-colindex="4" aria-label="Order Status" aria-sort="none">Order Status</th>
                                        <th v-on:click="changesSort" role="columnheader" aria-colindex="5" aria-label="Total Net" aria-sort="none">Total Net</th>
                                        <!--<th role="columnheader" aria-colindex="6" aria-label="Download">Download</th>-->
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="item in orderList" v-bind:key="item.orderId" :class="item.status == 'PAYMENT_ERROR' ? 'payment-failed' : ''" @click="showOrderDetails(item.orderId)">
                                        <td>{{item.dateCreated}}</td>
                                        <td>#{{item.orderId}}</td>
                                        <td>{{item.status}}</td>
                                        <td>$ {{item.totalPrice.toFixed(2)}} {{item.currency}}</td>
                                        <!--<td><a class="button-pdf" href="#">Download PDF</a></td>-->
                                    </tr>
                                </tbody>
                            </table>
                            <div class="no-sims" v-if="noOrders">
                                <h2 class="text">You have no orders</h2>
                            </div>
                        </div>
                    </div>
                    <div class="siot-table-footer">
                        <div class="siot-table-footer-center">
                            <nav v-if="paginationCount" aria-label="Page navigation example">
                                <paginate :click-handler="paginationControll" :page-count="paginationCount" v-model="sortSettings.page" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></paginate>
                            </nav>
                        </div>
                    </div>
                </div>
                <div class="loader-orders-list" v-if="loading && noOrders == false">
                    <div class="sk-wave">
                        <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                    </div>
                </div>
            </div>
        </div>
        <OrderDetailsModal v-if="orderId != null" @closeModal="closeModalOrder" @refreshList="getOrderList(false)" :orderIdModal="orderId"></OrderDetailsModal>
        <b-modal size="md" ref="fileFormatModal" id="fileFormatModal" centered hide-footer>
            <div class="file-format-popup">
                <img src="../../assets/img/file-format.svg">
                <h3>Save export file as:</h3>
                <div>
                    <button class="btn btn-primary csv" v-on:click="exportCsv">CSV</button>
                    <button class="btn btn-primary xls" v-on:click="exportXlsx">XLSX</button>
                </div>
                <button class="btn btn-light" @click="hideExportSelect()">Cancel</button>
            </div>
        </b-modal>
        <FTSSort v-if="mobileSort.visible" :settingsSort="sortingSettings" :directionSort="sortSettings.desc" :columnSort="sortSettings.sort" v-on:hideSort="shwoHideSort" v-on:submitSort="submitSort"></FTSSort>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Paginate from 'vuejs-paginate'
    import Axios from 'axios';
    import globalStore from '../../variables';
    import OrderDetailsModal from './OrderDetailsModal'
    import VueCookies from 'vue-cookies';
    import FTSSort from "../../ftsComponents/FTSSort";
    Vue.use(VueCookies);
    Vue.$cookies.config('7d','','',true)

    export default {
        name: "OrderHistory",
        components: {
            Paginate: Paginate,
            OrderDetailsModal: OrderDetailsModal,
            FTSSort
        },
        created() {
            this.showMobileElements();
            this.initialOpenModal();
            this.getOrderList(true);
        },
        data () {
            return {
                sortingSettings: [
                    {
                        label: 'Date',
                        column: 1
                    },
                    {
                        label: 'Invoice',
                        column: 2
                    },
                    {
                        label: 'Order Status',
                        column: 4
                    },
                    {
                        label: 'Total Net',
                        column: 5
                    },
                ],
                mobileSort: {
                    column: 0,
                    direction: 0,
                    visible: false
                },
                mobileVisible: false,
                filter: '',
                orderList: [],
                paginationCount: 0,
                searchString: '',
                sortSettings: {
                    page: 1,
                    size: 40,
                    sort: 1,
                    desc: true
                },
                orderId: null,
                orderIdModal: null,
                noOrders: false,
                loading: false,
                typingTimer: null
            }
        },
        methods: {
            submitSort(value) {
                this.sortSettings.sort = value.column;
                this.sortSettings.desc = value.direction;
                this.getOrderList(true);
            },
            shwoHideSort() {
                this.mobileSort.visible = (this.mobileSort.visible == true) ? false : true;
            },
            showMobileElements() {
                const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

                if (width < 992) {
                    this.mobileVisible = true;
                } else {
                    this.mobileVisible = false;
                }
            },
            goToOrder() {
                this.$router.push("/order/sims");
            },
            getOrderList(notPagination) {
                this.loading = true
                if (notPagination){
                    this.sortSettings.page = 1;
                }
                this.getPagination();
                Axios.get(globalStore.data.restApiUrl + "/orders"+ '?page=' + this.sortSettings.page + '&size=' + this.sortSettings.size + '&sort=' + this.sortSettings.sort + '&desc=' + this.sortSettings.desc + this.searchString)
                    .then(response => {
                        this.noOrders = false
                        let orderHistory = response.data;

                        this.orderList = orderHistory;

                        if (this.orderList.length == 0) {
                            this.noOrders = true
                        }
                        this.loading = false

                    }).catch(error => {
                    console.log(error)
                })
            },
            getPagination() {
                Axios.get(globalStore.data.restApiUrl + "/orders/page-count?size=" + this.sortSettings.size + this.searchString)
                    .then(response => {
                        if (response.status == 200) {
                            this.paginationCount = Number (response.data);
                        } else {
                            this.$notify({
                                type: 'warn',
                                group: 'notification',
                                title: 'Getting data error',
                                text: 'Error Sorting Order List - Contact Support',
                                duration: 3000,
                            });
                            console.log(response)

                            return false;
                        }
                    }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Error Sorting Order List - Contact Support',
                        duration: 3000,
                    });
                    console.log(error)

                    return false;
                })
            },
            paginationControll(ev) {
                this.sortSettings.page = ev;
                this.getOrderList(false);
            },
            changesSort: function(ev) {
                this.sortSettings.sort = ev.target.getAttribute("aria-colindex");

                if (ev.target.getAttribute("aria-sort") == 'none') {
                    document.querySelectorAll("table.table-managment thead th[aria-sort]").forEach(item => {
                        item.setAttribute("aria-sort", 'none')
                    })
                    ev.target.setAttribute("aria-sort", 'ascending')
                    this.sortSettings.desc = false
                } else if (ev.target.getAttribute("aria-sort") == 'ascending') {
                    ev.target.setAttribute("aria-sort", 'descending')
                    this.sortSettings.desc = true
                } else if (ev.target.getAttribute("aria-sort") == 'descending') {
                    ev.target.setAttribute("aria-sort", 'ascending')
                    this.sortSettings.desc = false
                }
                this.getOrderList(true);
            },
            searchKeyUp() {
                clearTimeout(this.typingTimer)
                this.typingTimer = setTimeout(() => {
                    this.searchRow()
                }, 500)
            },
            searchKeyDown() {
                clearTimeout(this.typingTimer)
            },
            searchRow: function () {
                if (this.filter.length > 2) {
                    this.searchString = '&search=' + escape(this.filter);
                } else {
                    this.searchString = '';
                }
                this.getOrderList(true);
            },
            sizePage: function () {
                this.getOrderList(true);
            },
            setTimeToLocal (data) {
                let dateHistoryTime = new Date(data.getTime() + data.getTimezoneOffset()*60*1000);

                if (dateHistoryTime.getHours() > 12) {
                    let tempHour = (dateHistoryTime.getHours() + 24) % 12 || 12;
                    if (dateHistoryTime.getMinutes() == 59) {
                        var hoursHistory = tempHour + ':' + ("0" + dateHistoryTime.getMinutes()).slice(-2) + ' PM'
                    } else {
                        var hoursHistory = tempHour + ':' + ("0" + (dateHistoryTime.getMinutes() + 1)).slice(-2) + ' PM'
                    }
                } else {
                    if (dateHistoryTime.getHours() == 0) {
                        var hoursHistory = '12' + ':' + ("0" + (dateHistoryTime.getMinutes() + 1)).slice(-2) + ' AM'
                    } else {
                        var hoursHistory = dateHistoryTime.getHours() + ':' + ("0" + (dateHistoryTime.getMinutes() + 1)).slice(-2) + ' AM'
                    }
                }

                let finalDate = data.getMonth() + 1 + '/' + data.getDate() + '/' + data.getFullYear() + ' ' + hoursHistory;
                return finalDate;
            },
            showOrderDetails(orderId) {
                this.orderId = orderId
            },
            closeModalOrder() {
                this.orderId = null
                console.log(this.orderId)
            },
            initialOpenModal() {
                if (this.$route.params.orderId) {
                    this.orderIdModal = this.$route.params.orderId;
                    this.showOrderDetails(this.orderIdModal);
                }
            },
            hideExportSelect() {
                this.$refs['fileFormatModal'].hide()

            },
            showExportSelect() {
                this.$refs['fileFormatModal'].show()
            },
            exportCsv() {
                this.$refs['fileFormatModal'].hide()

                let companyId = '';

                if (this.$cookies.get('userLevelId')) {
                    companyId = '?companyId=' + this.$cookies.get('companyId')
                }

                Axios.get(globalStore.data.restApiUrl + "/orders/csv" + companyId)
                    .then(response => {
                        let csvContent = "data:text/csv;charset=utf-8," + response.data;
                        var fileLink = document.createElement('a');fileLink.href = csvContent;
                        fileLink.setAttribute('download', 'Orders list.csv');
                        document.body.appendChild(fileLink);
                        fileLink.click();
                    }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'SIMs export went wrong',
                        text: 'Something went wrong during SIMs export. Please contact with support.',
                        duration: 3000,
                    });
                    console.log(error);
                });
            },
            exportXlsx() {
                this.$refs['fileFormatModal'].hide()

                let companyId = '';

                if (this.$cookies.get('userLevelId')) {
                    companyId = '?companyId=' + this.$cookies.get('companyId')
                }

                Axios.get(globalStore.data.restApiUrl + "/orders/xlsx" + companyId, {responseType: 'blob'})
                    .then((response) => {
                        const fileLink = URL.createObjectURL(new Blob([response.data],
                            {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                            )
                        );
                        const link = document.createElement('a')
                        link.href = fileLink
                        link.setAttribute('download', 'Orders list.xlsx')
                        document.body.appendChild(link)
                        link.click()
                    }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'SIMs export went wrong',
                        text: 'Something went wrong during SIMs export. Please contact with support.',
                        duration: 3000,
                    });
                    console.log(error);
                });
            }
        }
    }
</script>

<style lang="scss">
    .button-left {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 20px;
    }
    .order-history {
        .card {
            .card-body {
                padding: 12px 0 20px;
            }
        }
        .card-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }
    .order-history-card {
        position: relative;
        .fts-table {
            position: relative;
        }

        .loader-orders-list,
        .no-orders {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;

            background-color: rgba(255, 255, 255, 0.7);

            display: flex;
            justify-content: center;
            align-items: center;
            align-content: center;

            .sk-wave {
                height: 60px;

                .sk-rect {
                    width: 3px;
                    background-color: #39c354;
                    border-radius: 4px;
                }
            }

            .text {
                margin-top: 20px;
                text-align: center;
                font-size: 15px;
                font-weight: 700;
            }

            h2.text {
                margin-top: 180px;
            }
        }
    }

    .btn-order-blank-sims {
        display: block;
        margin-left: auto;
    }

    .show-label {
        line-height: 35px;
    }


    .button-pdf {
        display: inline-block;
        padding: 0 12px 0 0;
        height: 30px;
        background-color: #cc4b4c;
        border-radius: 5px;
        font: 400 12px/30px Roboto,Arial,sans-serif;
        color: #ffffff;

        &:before {
            content: "";
            display: inline-block;
            vertical-align: top;
            width: 30px;
            height: 30px;
            margin-right: 10px;
            border-radius: 5px;
            background: #973939 url('/img/pdf.svg') no-repeat 50%;
        }
    }

    #fileFormatModal___BV_modal_header_ {
        padding-bottom: 0;
    }

    #fileFormatModal___BV_modal_body_ {
        padding-top: 0;
        .file-format-popup {
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #fff;
            padding: 0 20px 20px;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;

            h3 {
                font-size: 15px;
                margin-top: 8px;
                margin-bottom: 20px;
            }

            .btn {
                width: 100px;
            }

            .btn-primary {
                margin: 0 10px 20px;
            }

            .btn-light {
                margin: 10px 0 0;
            }

            .csv {
                background-color: #00559F;
                border-color: #00559F;
            }
            .xls {
                background-color: #207245;
                border-color: #207245;
            }

            .close-icon {
                position: absolute;
                top: 20px;
                right: 20px;
                cursor: pointer;
            }
        }
    }

    .fts-bottom-table {
        position: relative;
        .btn-on-right {
            position: absolute;
            top: 20px;
            right: 20px;
        }
    }

    .dark-theme {
        .table-order-history {
            tbody {
                tr {
                    &.payment-failed {
                        td {
                            color: #FC4D4D;
                        }
                    }
                }
            }
        }
        .order-history-card {
            .loader-orders-list,
            .no-orders {
                background-color: rgba(0, 0, 0, 0.4);
            }
        }

         .table {
             color: #EDEEEF;

             thead {
                 tr {
                     th {
                         border-color: #1A1C1D;
                     }
                 }
             }

             tbody {
                 tr {
                     &:nth-of-type(odd) td {
                         background-color: #2F353A;
                     }
                     &:nth-of-type(even) td {
                         background-color: #3A4149;
                     }

                     td {
                         border-color: #1A1C1D;
                         .btn-secondary {
                             .fa-pencil {
                                 color: #EDEEEF;
                             }
                         }
                     }

                     &[aria-selected="false"] {
                         .fts-checkbox-table {
                             border-color: #EDEEEF;
                         }
                     }
                     &:hover td{
                         background-color: #0088FF;
                     }
                 }
             }
         }

        .container-fluid {
            .card {
                &.transparent-card {
                    background-color: transparent;
                    border-color: #2f353a;
                    .card-body {
                        background-color: transparent;
                        .form-control {
                            border-color: #1a1c1d;
                            background-color: #515b65;
                        }
                    }
                }
                .card-body {
                    .form-control {
                        border-color: #1a1c1d;
                        background-color: #515b65;
                        color: #EDEEEF;
                        &::placeholder {
                            color: #EDEEEF;
                        }
                    }
                }
            }
        }
        #fileFormatModal___BV_modal_content_ {
            background-color: #3a4149;
            color: #EDEEEF;

            button {
                color: #fff;
            }
            .file-format-popup {
                background-color: #3a4149;
                color: #EDEEEF;
            }

            .modal-body {
                button.btn-light {
                    color: #23282c;
                }
            }
        }
     }

    .order-history .fts-table-wrapper .fts-table table tbody tr td:first-child {
        width: 240px;
    }

    .button-mobile {
        display: none;
    }
</style>
